/**************
 Mobile Nav
 ***************/

// mobile slider nested dropdown
document.querySelectorAll(".sliderNavDropTop").forEach(element => {
    element.addEventListener("click", function () {
        this.classList.toggle("active");
    });
});

// open nav
function openNav() {
    document.querySelector("#slider").showModal();
    document.querySelector("body").classList.add("noScroll");
}

// dialog close event
document.querySelector("#slider").addEventListener("close", async function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close nav
async function closeNav() {
    document.querySelector("#slider").close();
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});


// open search menu
if (window.matchMedia('(min-width: 800px)').matches) {
    document.querySelector('.headerIconsItem.searchBtn').addEventListener('click', function () {
        this.classList.toggle('active');
        document.querySelector('#headerSearch').classList.toggle('active');
        document.querySelector('#searchExit').classList.toggle("active");

        // close any dropdowns
        document.querySelectorAll(".dropdownNavItem")?.forEach(element => {
            element.classList.remove('active');
        })
    });

    // close search menu
    document.querySelector('#headerSearchBarClose').addEventListener('click', function () {
        document.querySelector('#headerSearch').classList.remove('active');
        document.querySelector('.headerIconsItem.searchBtn').classList.remove('active');
    })

    // close the search
    document.querySelector("#searchExit")?.addEventListener("mouseenter", function () {
        this.classList.remove("active");
        document.querySelector('#headerSearch').classList.remove('active');
        document.querySelector('.headerIconsItem.searchBtn').classList.remove('active');
    });
}


if (window.matchMedia('(max-width: 800px)').matches) {
    // mobile search button goes to seach
    document.querySelector('.searchBtn').addEventListener('click', function (e) {
        e.preventDefault();
        window.location.href = window.Shopify.routes.root + `search`;
    });
}


// open dropdowns
document.querySelectorAll('.openMenu')?.forEach(function (element) {
    element.addEventListener("mouseover", function () {
        this.classList.toggle("active");

        document.querySelectorAll(".dropdownNavItem").forEach(element => {
            if (element.dataset.target !== this.dataset.target) {
                element.classList.remove('active');
            }
        });


        // close search if open
        document.querySelector('#headerSearch').classList.remove('active');
        document.querySelector('.headerIconsItem.searchBtn').classList.remove('active');

        // open dropdown nav
        let target = this.getAttribute("data-target");
        document.querySelector(`.dropdownNavItem[data-target="${target}"]`).classList.toggle('active');

        // toggle exit hover area
        // if at least one dropdown is open, show the exit hover area
        let openedDropdown = false;
        document.querySelectorAll('.dropdownNavItem').forEach(el => {
            if (el.classList.contains('active')) {
                openedDropdown = true;
            }
        })
        if (openedDropdown) {
            document.querySelector('#dropdownExit').classList.add("active");
        } else {
            document.querySelector('#dropdownExit').classList.remove("active");
        }

    })
})

// close the dropdown navigation
document.querySelector("#dropdownExit")?.addEventListener("mouseenter", function () {
    this.classList.remove("active");
    document.querySelectorAll('.dropdownNavItem').forEach(element => {
        element.classList.remove('active');
    });
    document.querySelectorAll('.openMenu').forEach(element => {
        element.classList.remove('active');
    });
});


const headerSectionId = document.querySelector('#header').dataset.sectionId;


// listen for predictive search
document.querySelector('#headerSearchBarFormInput').addEventListener('input', async function () {

    const searchTerm = this.value.trim();

    await fetch(window.Shopify.routes.root + `search/suggest?q=${(searchTerm)}&section_id=${headerSectionId}&resources[options][fields]=title,product_type,variants.title,variants.sku,title,tag`)
        .then((response) => {
            return response.text();
        })
        .then((text) => {
            // create temp div to parse html
            const html = document.createElement('div');
            html.innerHTML = text;

            let searchHTML = html.querySelector('#headerSearchBody');
            let linkHTML = html.querySelector('#headerSearchGo');

            // insert search results
            if (searchHTML && searchHTML.innerHTML.trim().length) {
                document.querySelector(`#headerSearchBody`).innerHTML = searchHTML.innerHTML;
                document.querySelector(`#headerSearchGo`).innerHTML = linkHTML.innerHTML;


                // listen for search result clicks
                document.querySelectorAll('.searchBtn')?.forEach(button => {
                    button.addEventListener('click', function (e) {
                        e.preventDefault()

                        window.location.href = window.Shopify.routes.root + `search?type=product&q=${(searchTerm)}`
                    })
                })

            }

        })
        .catch(e => {
            console.error(e);
        });
});


// mobile open/close search based on scroll
if (window.matchMedia('(max-width: 800px)').matches) {
    let scrollingUp = false;
    let lastScrollTop = 0;
    let ticking = false;
    const threshold = 5; // px before we consider it a direction change
    const headerSearch = document.querySelector('#headerSearch');

    function onScroll() {
        let currentScroll = window.scrollY;

        // direction only changes if movement passes threshold
        if (Math.abs(currentScroll - lastScrollTop) > threshold) {
            scrollingUp = currentScroll < lastScrollTop;
        }

        // if we are at the top of the page, always show the search
        if (currentScroll === 0) {
            headerSearch.classList.add('active');
        } else if (currentScroll > 0 && scrollingUp) {
            // scrolling up
            headerSearch.classList.add('active');
        } else {
            // scrolling down
            headerSearch.classList.remove('active');

            // remove the initial mobileActive class
            headerSearch.classList.remove('mobileActive');

        }

        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
        ticking = false;
    }

    // scroll event (throttled with requestAnimationFrame)
    window.addEventListener('scroll', function () {
        if (!ticking) {
            window.requestAnimationFrame(onScroll);
            ticking = true;
        }
    });
}